import { DownloadIcon } from 'lucide-react';

const TEXT = '#404f4d';
const BORDER = '#e5e7eb';

type QboExportRow = {
  id?: string;
  date?: string;
  donorName?: string;
  paymentMethod?: string;
  amountCents?: number;
  status?: string;
};

type QboExportFilters = {
  status?: string;
  dateRange?: { from: string; to: string };
  campaignType?: string;
};

export function QboExportButton({
  entries,
  filters,
}: {
  entries: QboExportRow[];
  filters: QboExportFilters;
}) {
  const handleExport = () => {
    const header = ['donation_id', 'date', 'donor_name', 'payment_method', 'amount_dollars', 'status'];
    const rows = entries.map((entry) => [
      entry.id ?? '',
      entry.date ?? '',
      entry.donorName ?? '',
      entry.paymentMethod ?? '',
      typeof entry.amountCents === 'number' ? (entry.amountCents / 100).toFixed(2) : '0.00',
      entry.status ?? '',
    ]);
    const csv = [header, ...rows]
      .map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(','))
      .join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const dateSuffix = filters.dateRange?.from && filters.dateRange?.to
      ? `${filters.dateRange.from}_to_${filters.dateRange.to}`
      : new Date().toISOString().slice(0, 10);
    link.href = downloadUrl;
    link.download = `donations-ledger-qbo-${dateSuffix}.csv`;
    link.click();
    URL.revokeObjectURL(downloadUrl);
  };

  return (
    <button
      type="button"
      onClick={handleExport}
      disabled={entries.length === 0}
      className="inline-flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60"
      style={{ borderColor: BORDER, color: TEXT }}
      title={entries.length === 0 ? 'No ledger rows available to export' : 'Export filtered ledger rows to CSV'}
      aria-label="Export donations ledger rows to CSV"
    >
      <DownloadIcon className="h-4 w-4" aria-hidden="true" />
      Export QBO
    </button>
  );
}
